<ion-content [fullscreen]="true">
  <div>
    <section class="user-summary-section">
      <div>
        <app-charity-avatar [avatarUrl]="_imageUrl" (upload)="updateImage($event)"></app-charity-avatar>
        <label class="ic-plus-label" for="single" aria-label="Change charity logo">
          <ion-icon id="ic-plus" color="primary" name="add-circle" aria-hidden="true"></ion-icon>
        </label>
      </div>
      <div class="charity-info">
        <ion-label>
          <p class="charity-name">{{charityName}}</p>
          <br />
        </ion-label>
      </div>
    </section>

    <ion-list>

      <ion-item lines="none"  [button]="true" (click)="goToOrders()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Orders</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Marketplace Orders</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none"  [button]="true" (click)="goToDonationHistory()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Donation History</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Marketplace Orders</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none"  [button]="true" (click)="goToFollowers()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>My Followers</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Marketplace Orders</ion-note>
        </ion-label>
      </ion-item>

      <!-- Stripe Connect - Only show for OWNER/ADMIN -->
      @if (canManageDonations) {
        <ion-item lines="none"  [button]="true" (click)="goToAccountManagement()">
          <div class="unread-indicator-wrapper" slot="start"></div>
          <ion-label>
            <ion-text>Stripe Connect</ion-text>
            <br />
            <ion-note color="medium" class="ion-text-wrap">Manage Your Stripe Account</ion-note>
          </ion-label>
        </ion-item>
      }

      <ion-item lines="none"  [button]="true" (click)="goToRecurringDonations()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Recurring Donations</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Manage Donation Subscriptions</ion-note>
        </ion-label>
      </ion-item>

      <!-- Team Management - Only show for OWNER/ADMIN -->
      @if (canManageTeam) {
        <ion-item lines="none"  [button]="true" (click)="goToTeamManagement()">
          <div class="unread-indicator-wrapper" slot="start"></div>
          <ion-label>
            <ion-text>Team Management</ion-text>
            <br />
            <ion-note color="medium" class="ion-text-wrap">Invite and Manage Team Members</ion-note>
          </ion-label>
        </ion-item>
      }

      <!-- Settings - Only show for OWNER/ADMIN -->
      @if (canManageTeam) {
        <ion-item lines="none"  [button]="true" (click)="goToSettings()">
          <div class="unread-indicator-wrapper" slot="start"></div>
          <ion-label>
            <ion-text>Settings</ion-text>
            <br />
            <ion-note color="medium" class="ion-text-wrap">Manage Permissions and Settings</ion-note>
          </ion-label>
        </ion-item>
      }

    </ion-list>

    <div class="btn-user">
      <button (click)="switchToUser()">Switch to User Portal</button>
    </div>

    <div class="btn-signout">
      <button (click)="signOut()">Log Out</button>
    </div>
  </div>
</ion-content>
